var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAndroid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 84.6 100",
    style: {
      enableBackground: "new 0 0 84.6 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M6.2,32.4c-1.7,0-3.2,0.6-4.4,1.8S0,36.8,0,38.5v25.8c0,1.7,0.6,3.2,1.8,4.4 C3,70,4.5,70.6,6.2,70.6c1.7,0,3.2-0.6,4.4-1.8c1.2-1.2,1.8-2.7,1.8-4.4V38.5c0-1.7-0.6-3.1-1.8-4.3S7.9,32.4,6.2,32.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M55.9,9.2l4.3-7.9c0.3-0.5,0.2-0.9-0.3-1.2C59.4-0.1,59,0,58.7,0.5l-4.3,7.9 c-3.8-1.7-7.8-2.5-12.1-2.5c-4.2,0-8.3,0.8-12.1,2.5l-4.3-7.9c-0.3-0.5-0.7-0.6-1.2-0.4c-0.5,0.3-0.6,0.7-0.3,1.2l4.3,7.9 c-4.3,2.2-7.8,5.3-10.3,9.2c-2.6,3.9-3.8,8.3-3.8,13h55.6c0-4.7-1.3-9-3.8-13C63.7,14.5,60.2,11.4,55.9,9.2z M31.3,20.6 c-0.5,0.5-1,0.7-1.7,0.7c-0.6,0-1.2-0.2-1.6-0.7c-0.4-0.5-0.7-1-0.7-1.7c0-0.6,0.2-1.2,0.7-1.7c0.4-0.5,1-0.7,1.6-0.7 s1.2,0.2,1.7,0.7c0.5,0.5,0.7,1,0.7,1.7C32,19.6,31.7,20.2,31.3,20.6z M56.6,20.6c-0.4,0.5-1,0.7-1.6,0.7c-0.6,0-1.2-0.2-1.7-0.7 c-0.5-0.5-0.7-1-0.7-1.7c0-0.6,0.2-1.2,0.7-1.7c0.5-0.5,1-0.7,1.7-0.7c0.6,0,1.2,0.2,1.6,0.7c0.4,0.5,0.7,1,0.7,1.7 C57.3,19.6,57.1,20.2,56.6,20.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M14.7,73.6c0,1.8,0.6,3.4,1.9,4.7c1.3,1.3,2.8,1.9,4.7,1.9h4.4l0.1,13.6c0,1.7,0.6,3.2,1.8,4.4 c1.2,1.2,2.6,1.8,4.3,1.8c1.7,0,3.2-0.6,4.4-1.8c1.2-1.2,1.8-2.7,1.8-4.4V80.2h8.3v13.6c0,1.7,0.6,3.2,1.8,4.4 c1.2,1.2,2.7,1.8,4.4,1.8c1.7,0,3.2-0.6,4.4-1.8c1.2-1.2,1.8-2.7,1.8-4.4V80.2h4.5c1.8,0,3.3-0.6,4.6-1.9c1.3-1.3,1.9-2.8,1.9-4.7 v-40H14.7V73.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M78.4,32.4c-1.7,0-3.1,0.6-4.3,1.8c-1.2,1.2-1.8,2.6-1.8,4.4v25.8c0,1.7,0.6,3.2,1.8,4.4 s2.6,1.8,4.3,1.8c1.7,0,3.2-0.6,4.4-1.8c1.2-1.2,1.8-2.7,1.8-4.4V38.5c0-1.7-0.6-3.2-1.8-4.4C81.6,33,80.1,32.4,78.4,32.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.a6c83dec73337663a7b85c84f2b2c6e8.svg";
export { ForwardRef as ReactComponent };